// Configuration Sentry du front, sortie de main.jsx pour être testable.
//
// Choix (plan 2026-09-28-sentry-optimization) :
//  - Pas de Session Replay : même en mode « sur erreur », l'intégration
//    enregistre en continu un tampon DOM sur chaque appareil — exactement la
//    pression mémoire qui fait tuer le renderer WebKit sur iPhone. Pour
//    corriger via le MCP Sentry, stack trace + breadcrumbs suffisent.
//  - Traces à 5 % en production : assez pour repérer les requêtes lentes.
//  - Rien n'est envoyé depuis le dev (≈ 15 % du quota gratuit en sept. 2026) ;
//    VITE_SENTRY_ENABLE_DEV=true pour un test local ponctuel.

// Erreurs jetées avant envoi. Garder chaque motif justifié.
const IGNORED_ERROR_PATTERNS = [
  /ResizeObserver loop/i,
  /Network Error/i,
  /AbortError|canceled/i,
  // Script injecté par Safari iOS : frame « undefined:1705 », symbole absent
  // de notre code (KAIYLO-FRONTEND-A, 217 événements / 14 j).
  /Can't find variable: EmptyRanges/i,
];

// Fonctions du script injecté par le navigateur intégré d'Instagram (iOS) :
// son postMessage vers l'app plante sur un focus ou un clic de formulaire
// (KAIYLO-FRONTEND-7Q/7R, /register). On filtre sur la pile, pas sur le
// message « The object does not support… », trop général.
const IGNORED_FRAME_FUNCTIONS = new Set(['dispatchToBridge', 'sendPostMessage']);

export function shouldDropEvent(event) {
  const exception = event?.exception?.values?.[0];
  const msg = exception?.value || '';
  if (IGNORED_ERROR_PATTERNS.some((re) => re.test(msg))) return true;
  const frames = exception?.stacktrace?.frames || [];
  return frames.some((f) => IGNORED_FRAME_FUNCTIONS.has(f.function));
}

export function buildSentryConfig({ Sentry, env, safeMode, release }) {
  const isDev = !!env.DEV;
  return {
    dsn: env.VITE_SENTRY_DSN,
    enabled: !isDev || env.VITE_SENTRY_ENABLE_DEV === 'true',
    environment: env.MODE,
    release,
    integrations: [Sentry.browserTracingIntegration()],
    initialScope: { tags: { safe_mode: String(safeMode) } },
    tracesSampleRate: isDev ? 1.0 : 0.05,
    beforeSend(event) {
      return shouldDropEvent(event) ? null : event;
    },
    beforeBreadcrumb(breadcrumb) {
      if (breadcrumb.category === 'console' && breadcrumb.level === 'log') return null;
      return breadcrumb;
    },
  };
}
